export function findParents<T extends { [key in K]?: T }, K extends 'parent'>(child: T): T[];
export function findParents<T extends { [key in K]?: T }, K extends string = 'parent'>(child: T, key?: K): T[];
export function findParents<T extends { [key in K]?: T }, K extends string = 'parent'>(child: T, key = 'parent'): T[] {
	const path: T[] = [];
	for (let el = child[key as K] as T; el; el = el[key as K] as T) path.push(el);
	return path;
}
